import React from 'react';

interface GameOverViewProps {
  statusMessage: string;
  onStartNewGame: (word: string) => void;
}

export const GameOverView: React.FC<GameOverViewProps> = ({ statusMessage, onStartNewGame }) => {
  const [newWord, setNewWord] = React.useState('');

  const isSecretWordValid = (word: string) => {
    const trimmed = word.trim();
    return trimmed.length >= 2 && trimmed.length <= 50;
  };

  const handleStartGame = () => {
    if (isSecretWordValid(newWord)) {
      onStartNewGame(newWord);
      setNewWord('');
    }
  };

  return (
    <div style={{
      width: '100%',
      height: '100vh',
      background: 'linear-gradient(135deg, #6366f1 0%, #3b82f6 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '40px'
    }}>
      <div style={{ flex: 1 }} />

      <h1 style={{
        fontSize: '40px',
        fontWeight: 'bold',
        color: 'white',
        textAlign: 'center',
        margin: 0
      }}>
        {statusMessage}
      </h1>

      <div style={{ flex: 1 }} />

      <div style={{
        width: '100%',
        maxWidth: '400px',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <p style={{
          fontSize: '16px',
          fontWeight: '600',
          color: 'white',
          textAlign: 'center'
        }}>
          Start next game
        </p>

        <input
          type="text"
          placeholder="New secret word"
          value={newWord}
          onChange={(e) => setNewWord(e.target.value)}
          style={{
            padding: '16px',
            fontSize: '18px',
            borderRadius: '12px',
            border: 'none',
            background: 'white',
            color: 'black'
          }}
        />

        <button
          onClick={handleStartGame}
          disabled={!isSecretWordValid(newWord)}
          style={{
            padding: '16px',
            fontSize: '16px',
            fontWeight: 'bold',
            borderRadius: '12px',
            border: 'none',
            background: isSecretWordValid(newWord) ? '#10B981' : 'rgba(128, 128, 128, 0.5)',
            color: 'white',
            cursor: isSecretWordValid(newWord) ? 'pointer' : 'not-allowed'
          }}
        >
          Start New Game
        </button>
      </div>

      <div style={{ flex: 1 }} />
    </div>
  );
};
